import UserAvatar from './UserAvatar'

export default UserAvatar
// eslint-disable-next-line import/export
export * from './UserAvatar'
